import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const reviewMembershipApi = generateNomenApi(`/review/review-membership`);

export const reviewMembershipOptions = generateNomenOptions('review-membership', reviewMembershipApi);
